import React, { useCallback, useContext, useState } from "react";
import FilterSecondPage_Jupiter from "./FilterSecondPage_Jupiter";
import TopkpisSecond_Jupiter from "./TopkpisSecond_Jupiter";
import TopkpisSecondMain_Jupiter from "./TopkpisSecondMain_Jupiter";
import RealWorldBox_Jupiter from "./SecondPageCharts_Jupiter/RealWorldBox_Jupiter";
import NetEnergydBox_Jupiter from "./SecondPageCharts_Jupiter/NetEnergydBox_Jupiter";
import RealWorldBar_Jupiter from "./SecondPageCharts_Jupiter/RealWorldBar_Jupiter";
import NetEnergyBar_Jupiter from "./SecondPageCharts_Jupiter/NetEnergyBar_Jupiter";
import ModeUtilization_Jupiter from "./SecondPageCharts_Jupiter/ModeUtilization_Jupiter";
import AvgDDBar_Jupiter from "./SecondPageCharts_Jupiter/AvgDDBar_Jupiter";
import Torquespeed_Jupiter from "./SecondPageCharts_Jupiter/Torquespeed_Jupiter";
import TorqueBox_Jupiter from "./SecondPageCharts_Jupiter/TorqueBox_Jupiter";
import Modal_Jupiter from "./SecondPageCharts_Jupiter/Modal_Jupiter";
import moment from "moment";
import { INIT_FILTER_STATE } from "../../../constants/driveglobalfilterinitialstates_coral";

import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";

function PageSecond_Jupiter(props) {
  const [secondPageState, setSecondPageState] = useState({
    startDate: props.gloablfilter.startDate,
    endDate: props.gloablfilter.endDate,
    vin_num: props.gloablfilter.VIN_NUM.toString(),
    soc_per: props.gloablfilter.SOC,
  });

  const filterSubmited = useCallback((data) => {
    setSecondPageState(data);
  }, []);

  const pageChange = useCallback((data) => {
    props.pageChange();
  }, []);

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <FilterSecondPage_Jupiter
        onsubmit={filterSubmited}
        pageChange={pageChange}
        secondPageState={secondPageState}
      />
      <div className="container-fluid">
        <TopkpisSecond_Jupiter
          gloablfilter={secondPageState}
          apiend="jupiter_drive_analysis/topkpis"
        />
        <TopkpisSecondMain_Jupiter
          gloablfilter={secondPageState}
          apiend="drivesecondpage/topkpismain"
        />
        <section className="graphs">
          <div className="row">
            <div className="col-md-12 col-sm-6 col-lg-6">
              <div className="chartbox">
                <div className="row">
                  <RealWorldBox_Jupiter
                    gloablfilter={secondPageState}
                    apiend="drivesecondpagecharts/realworldbox"
                  />
                  <div className="col-md-6">
                    <RealWorldBar_Jupiter
                      apiend="drivesecondpagecharts/realworldbar"
                      gloablfilter={secondPageState}
                    ></RealWorldBar_Jupiter>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-sm-6 col-lg-6 pl-0 evtpks-pl0">
              <div className="chartbox">
                <div className="row">
                  <NetEnergydBox_Jupiter
                    gloablfilter={secondPageState}
                    apiend="drivesecondpagecharts/netenergybox"
                  ></NetEnergydBox_Jupiter>
                  <div className="col-md-6">
                    <NetEnergyBar_Jupiter
                      apiend="drivesecondpagecharts/netenergybar"
                      gloablfilter={secondPageState}
                    ></NetEnergyBar_Jupiter>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Row Ends here */}
          <div className="row mt-4 mb-3 equal-cols">
            {loggedInUser.flagForHideShow === "ERC" && (
              <div className="col-md-3 col-sm-12 pr-0 ">
                <Torquespeed_Jupiter
                  apiend="drivesecondpagecharts/torquespeed"
                  gloablfilter={secondPageState}
                ></Torquespeed_Jupiter>
              </div>
            )}
            {loggedInUser.flagForHideShow === "ERC" && (
              <div className="col-md-3 col-sm-12 pr-0">
                <TorqueBox_Jupiter
                  apiend="drivesecondpagecharts/torquebox"
                  gloablfilter={secondPageState}
                ></TorqueBox_Jupiter>
              </div>
            )}
            <div
              className={
                loggedInUser.flagForHideShow === "ERC"
                  ? "col-md-3 col-sm-12 pr-0"
                  : "col-md-12 col-sm-6 col-lg-6"
              }
            >
              <div className="v-title chartbox">
                <div className="titlebg">Soc Discharge/Cycle Analysis</div>
                <AvgDDBar_Jupiter
                  apiend="drivesecondpagecharts/avgddBar"
                  gloablfilter={secondPageState}
                ></AvgDDBar_Jupiter>
              </div>
            </div>
            <div
              className={
                loggedInUser.flagForHideShow === "ERC"
                  ? "col-md-3 col-sm-12 pr-0"
                  : "col-md-12 col-sm-6 col-lg-6 pl-0 evtpks-pl0"
              }
            >
              <div className="v-title chartbox">
                <div className="titlebg">Mode utilization</div>
                <ModeUtilization_Jupiter
                  gloablfilter={secondPageState}
                  apiend="drivesecondpagecharts/modeutilization"
                ></ModeUtilization_Jupiter>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default PageSecond_Jupiter;
